import "./EndscreenElement.css";
import { Score } from "./Score";

export class EndscreenElement extends HTMLElement {
  constructor(score: Score) {
    super();
    this.innerHTML = `
      <h1>Game Over</h1>
      <div>
        <div><span>Score:</span><b>${score.count}</b></div>
        <div><span>Time:</span><b>${score.time}</b></div>
        <div><span>Highscore:</span><b>${score.highscore}</b></div>
      </div>
      <a href="/">Play Again</a>
    `;
    document.body.append(this);
  }
}

customElements.define("endscreen-element", EndscreenElement);
